import { defineComponent as r, computed as a, openBlock as d, createElementBlock as c, normalizeClass as m, renderSlot as u } from "vue";
const p = ["arial-label", "title", "tabindex", "disabled"], g = /* @__PURE__ */ r({
  __name: "ButtonIcon",
  props: {
    theme: { default: "dark" },
    label: {},
    size: { default: "md" },
    tabindex: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(l) {
    const t = l, o = /* @__PURE__ */ new Map([
      ["light", "hb-btn-icon--light"],
      ["light-border", "hb-btn-icon--light-border"],
      ["dark", "hb-btn-icon--dark"],
      ["gray", "hb-btn-icon--gray"],
      ["primary", "hb-btn-icon--primary"]
    ]), i = /* @__PURE__ */ new Map([
      ["sm", "hb-btn-icon--sm"],
      ["md", "hb-btn-icon--md"]
    ]), s = a(() => t.active ? "is-active" : ""), b = a(() => [
      o.get(t.theme),
      i.get(t.size),
      s.value
    ]);
    return (e, n) => (d(), c("button", {
      class: m(["hb-btn-icon", b.value]),
      "arial-label": e.label,
      title: e.label,
      tabindex: e.tabindex,
      type: "button",
      role: "button",
      disabled: e.disabled,
      onClick: n[0] || (n[0] = (h) => e.$emit("click"))
    }, [
      u(e.$slots, "default")
    ], 10, p));
  }
});
export {
  g as _
};
